module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-f0666e191f9085fc3de3ed484b6b7fae.svg#arrow",
      toString: function () {
        return this.url;
      }
    }